import { Button, H2 } from '@/components';
import CommonBlok from '@/components/common-blok';
import React from 'react';
import * as styles from './index.module.less';
import { PublicArrowRightTail } from 'notta-web-icon';

import { ReactComponent as LineLeftDeco } from '@/images/svg/line-left-deco.svg';
import { ReactComponent as LineRightDeco } from '@/images/svg/line-right-deco.svg';
import { BottomCtaData, IBottomCtaData } from '../../constants';
import { LoadingImageUrl } from '@/constants';

const BottomCtaCard = (data: IBottomCtaData) => {
  return (
    <div className={styles.bottom_cta_card}>
      <div className={styles.img_text_container}>
        <div className={styles.card_img}>
          <img
            src={LoadingImageUrl}
            data-src={data.withPic.src}
            className="lozad"
            style={{ objectFit: 'cover' }}
            data-object-fit="contain"
            alt={data.withPic.alt}
          />
        </div>
        <div className={styles.text_container}>
          {data.tips && <p className={styles.card_tips}>{data.tips}</p>}
          <p>{data.desc}</p>
        </div>
      </div>
      <div className={styles.btn_container}>
        <a href={data.btn.link} data-gtm={data.btn.id}>
          <Button type={data.btn.type}>
            {data.btn.text}
            {data.btn.type === 'link' && <PublicArrowRightTail />}
          </Button>
        </a>
      </div>
    </div>
  );
};

const BottomCta = () => {
  return (
    <CommonBlok
      isNewLayout
      title={
        <div className={styles.blok_title}>
          <LineLeftDeco stroke="#3164FF" />
          <H2 className={styles.title_header}>今すぐ無料で始めましょう！</H2>
          <LineRightDeco stroke="#3164FF" />
        </div>
      }
      className={styles.bottom_cta_blok}
    >
      <div className={styles.blok_content}>
        {BottomCtaData.map((item, index) => {
          return <BottomCtaCard key={index} {...item} />;
        })}
      </div>
    </CommonBlok>
  );
};
export default BottomCta;
